/*
    Create by gaokaizhi 2017-10-19
*/
"use strict";
angular.module("sortOfSitesModule", [])
    .factory('sortOfSitesService', ['$modal', function($modal) {
        return {
            sorts: function(type, curpos, selectedArray, array, confirm, cancel) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/website/service/SitesSort/sortOfSites_tpl.html",
                    windowClass: 'sort-of-sites-window',
                    backdrop: false,
                    controller: "sortOfSitesCtrl",
                    resolve: {
                        params: function() {
                            return {
                                type: type,
                                curpos: curpos,
                                selectedArray: selectedArray,
                                array: array
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    if (angular.isFunction(confirm)) confirm(result);
                }, function() {
                    if (angular.isFunction(cancel)) cancel();
                });
            },


        }
    }])
    .controller("sortOfSitesCtrl", ["$scope", "$modalInstance", "$modal", "params", "modalDialog", "trsHttpService", function($scope, $modalInstance, $modal, params, modalDialog, trsHttpService) {
        var initData = function() {
            $scope.sitePosition = [{
                    value: 1,
                    name: "最前"
                },
                {
                    value: 2,
                    name: "最后"
                },
                {
                    value: 3,
                    name: "指定位置"
                }

            ];
            $scope.list = {
                value: 1,
                curPosition: params.curpos,
                aimedPosition: "",
                totalLength: params.array.length
            };
        };
        initData();
        $scope.params = {
            serviceid: "mlf_websiteoper",
            methodname: "orderWebSites",
            startSiteId: params.selectedArray.SITEID,
            targetSiteId: ""
        };
        var appParams = {
            serviceid: "mlf_appconfig",
            methodname: "orderWebSites",
            startSiteId: params.selectedArray.SITEID,
            targetSiteId: ""
        }
        var save = function() {
            if (params.type == "website") {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                    modalDialog.alertType("保存成功", "", "success", false);
                    $modalInstance.close(data);
                });
            } else if (params.type == "app") {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), appParams, "get").then(function(data) {
                    modalDialog.alertType("保存成功", "", "success", false);
                    $modalInstance.close(data);
                });
            }

        };
        $scope.confirm = function() {
            switch ($scope.list.value) {
                case 1:
                    $scope.params.targetSiteId = params.array[0].SITEID;
                    appParams.targetSiteId = params.array[0].SITEID;
                    save();
                    break;
                case 2:
                    $scope.params.targetSiteId = params.array[$scope.list.totalLength - 1].SITEID;
                    appParams.targetSiteId = params.array[$scope.list.totalLength - 1].SITEID;
                    save();
                    break;
                case 3:
                    if (isNaN($scope.list.aimedPosition - 1) || $scope.list.aimedPosition < 1 || $scope.list.aimedPosition > $scope.list.totalLength || Math.floor($scope.list.aimedPosition) != $scope.list.aimedPosition) {
                        modalDialog.alertType("排序失败", "请输入1到" + $scope.list.totalLength + "之间的正整数", "error", false);
                        return;
                    }
                    $scope.params.targetSiteId = params.array[$scope.list.aimedPosition - 1].SITEID;
                    appParams.targetSiteId = params.array[$scope.list.aimedPosition - 1].SITEID;
                    save();
                    break;
            };

        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.site = params.selectedArray.SITEDESC;
    }]);